import VueCookie from "vue-cookies"

window._ = require("lodash")
window.html2canvas = require("html2canvas")

import { constants } from "./constants"

window.axios = require("axios")
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
window.axios.defaults.headers.common["X-Tenant-Subdomain"] = constants.SUBDOMAIN

Array.prototype.swapItems = function (a, b) {
  this[a] = this.splice(b, 1, this[a])[0]
  return this
}

let certreg_token = VueCookie.get(constants.COOKIE_PREFIX + "certreg_token")
let tenant_id = VueCookie.get(constants.COOKIE_PREFIX + "tenant_id")

if (certreg_token) axios.defaults.headers.common["X-CertRegToken"] = certreg_token
if (tenant_id) axios.defaults.headers.common["X-TenantId"] = tenant_id

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content
} else {
  // eslint-disable-next-line
  console.error("CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token")
}
